export const required = (message = 'Du har glömt att fylla i fältet') => value => {
    if (!value) {
        return message;
    } else if (Array.isArray(value) || typeof value === 'string') {
        return value.length === 0 ? message : undefined;
    }
    return undefined;
};

export const combineValidators = (validators = []) => {
    return value => {
        return validators.map(validator => validator(value)).find(e => e);
    };
};

export const validOmbudsnr = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }

    if (!value.match(/^[0-9]{1,7}$/)) {
        return message;
    }
};

export const validPostalCode = (message = 'Ogiltigt format') => value => {
    if (!value) {
        return message;
    }

    if (!value.match(/^[0-9]{3}\s?[0-9]{2}$/)) {
        return message;
    }
};

export const validOrgnr = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }

    if (value.indexOf('-') === -1) {
        if (value.length === 10) {
            value = value.slice(0, 6) + '-' + value.slice(6);
        } else {
            value = value.slice(0, 8) + '-' + value.slice(8);
        }
    }

    if (!value.match(/^(([1]{1}[6]{1})?([12356789]{1}[0-9]{5})[0-9|-]{4,5})$/)) {
        return message;
    }
};

export const validSSN = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }
    if (value.indexOf('-') == -1) {
        if (value.length == 10) {
            value = value.slice(0, 6) + '-' + value.slice(6);
        } else {
            value = value.slice(0, 8) + '-' + value.slice(8);
        }
    }
    if (
        !value.match(
            /^([12]{1}[90]{1})?[0-9]{2}([0]{1}[1-9]{1}|[1]{1}[0-2])([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1}|[6]{1}[1-9]{1}|[7-8]{1}[0-9]{1}|[9]{1}[0-1]{1})-?[0-9]{4}$/
        ) ||
        (!value.match(/^(?:19|20).{11}$/) && value.length === 13)
    ) {
        return message;
    }
    //Clean value
    value = value.replace('-', '');
    if (value.length == 12) {
        value = value.substring(2);
    }
    // Declare variables
    var sum = 0;
    var numdigits = value.length;
    var parity = numdigits % 2;
    var i;
    var digit;
    // Check luhn algorithm
    for (i = 0; i < numdigits; i = i + 1) {
        digit = parseInt(value.charAt(i));
        if (i % 2 == parity) {
            digit *= 2;
        }
        if (digit > 9) {
            digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 == 0 ? undefined : message;
};
export const validRegNr = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }

    if (!value.match(/^([a-zA-Z]{3})([\d]{2})([\d]|[a-zA-Z]{1})$/)) {
        return message;
    }
};

export const validDate = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }

    if (
        !value.match(
            /^([12]{1}[90]{1})?[0-9]{2}([0]{1}[1-9]{1}|[1]{1}[0-2])([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})$/
        )
    ) {
        return message;
    }
};

export const validYear = (message = 'Ogiltigt format') => value => {
    // Check valid length & form
    if (!value) {
        return message;
    }

    if (!value.match(/^(^[0-9]*$)$/)) {
        return message;
    }
};

export const validStudentAge = (message = 'Otillåten ålder') => value => {
    //Declare date variables
    const today = new Date();
    let birthDay = new Date();

    //Check for 10 or 11 digit ssn
    if (value && (value.length === 10 || value.length === 11)) {
        //get users year of birth and current year
        let inputYear = parseInt(value.slice(0, 2));
        let currentYear = parseInt(
            today
                .getFullYear()
                .toString()
                .slice(2, 4)
        );

        //set the year to start with either 19 or 20
        let year = inputYear <= currentYear ? 2000 + inputYear : 1900 + inputYear;
        let month = parseInt(value.slice(2, 4)) - 1; // Month is zero-based
        let day = parseInt(value.slice(4, 6));

        //set birthday
        birthDay.setFullYear(year, month, day);

        //check for 12 or 13 digit ssn
    } else if (value && (value.length === 12 || value.length === 13)) {
        let year = parseInt(value.slice(0, 4));
        let month = parseInt(value.slice(4, 6)) - 1; // Month is zero-based
        let day = parseInt(value.slice(6, 8));

        //set birthday
        birthDay.setFullYear(year, month, day);
    } else {
        return message;
    }

    //calculate user age
    let age = today.getFullYear() - birthDay.getFullYear();
    const monthDiff = today.getMonth() - birthDay.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDay.getDate())) {
        age--;
    }

    //Check the users age
    if (age > 39) {
        return message;
    }
};
